import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import MKBox from "components/MKBox";

function NavbarFrame({ sticky, transparent, light, relative, children }) {
  return (
    <Container sx={sticky ? { position: "sticky", top: 0, zIndex: 10 } : null}>
      <MKBox
        py={1}
        px={{ xs: 4, sm: transparent ? 2 : 3, lg: transparent ? 0 : 2 }}
        my={relative ? 0 : 2}
        mx={relative ? 0 : 3}
        width={relative ? "100%" : "calc(100% - 48px)"}
        borderRadius="xl"
        shadow={transparent ? "none" : "md"}
        color={light ? "white" : "dark"}
        position={relative ? "relative" : "absolute"}
        left={0}
        zIndex={3}
        sx={({ palette: { transparent: transparentColor, white }, functions: { rgba } }) => ({
          backgroundColor: transparent ? transparentColor.main : rgba(white.main, 0.8),
          backdropFilter: transparent ? "none" : `saturate(200%) blur(30px)`,
        })}
      >
        {children}
      </MKBox>
    </Container>
  );
}

NavbarFrame.defaultProps = {
  sticky: false,
  transparent: false,
  light: false,
  relative: false,
};

NavbarFrame.propTypes = {
  sticky: PropTypes.bool,
  transparent: PropTypes.bool,
  light: PropTypes.bool,
  relative: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default NavbarFrame;
